import React from 'react';
import Button from "../../../forms/Button";

const MakePendingPaymentModalContent = ({ setModalClose }) => {
  return (
    <>
      <div className="space-y-6">
        <div className="space-y-2">
          <h3 className="text-2xl font-medium text-md-dark">There is a pending payment for your the order.</h3>
          <div className="text-base text-slate-500">Your order has been placed, but the payment has not yet been completed. To proceed with processing and shipping your order, please complete the payment as soon as possible.</div>
          <div className="text-base text-slate-500">
            <ul className="list-disc list-outside pl-6">
              <li>Status: Awaiting payment confirmation.</li>
              <li>Action Required: Complete the payment to avoid automatic cancellation.</li>
              <li>Payment Methods: You can pay using your preferred method from the available options.</li>
              <li>Deadline: Orders with pending payments may be cancelled if not completed within 24–48 hours.</li>
            </ul>
          </div>
          <div className="text-sm text-slate-500">If you believe this is an error or you've already made the payment, please contact our support team with your transaction details.</div>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-md-pink-light-1 flex items-start justify-between gap-4">
        <div className="ml-auto flex-shrink-0 flex items-center gap-1 md:gap-2">
          <Button buttonHasLink={false} buttonIcon={"fa-regular fa-fw fa-xmark"} buttonIconPosition={"left"} buttonLabel={"Close"} buttonClasses={"!h-10 !rounded-md !px-3 !bg-md-pink-light-2 border border-md-pink-light-1 !text-md-pink hover:!bg-md-pink-light-1 hover:border-md-pink/20"} buttonLabelClasses={"!font-medium !pb-1 !leading-none"} buttonFunction={() => setModalClose(false)} />
          <Button buttonHasLink={false} buttonIcon={"fa-regular fa-fw fa-credit-card-front"} buttonIconPosition={"left"} buttonLabel={"Make Payment"} buttonClasses={"!h-10 !rounded-md !px-3"} buttonLabelClasses={"!font-medium !pb-1 !leading-none"} buttonFunction={() => setModalClose(false)} />
        </div>
      </div>
    </>
  );
};

export default MakePendingPaymentModalContent;